import { validPin } from './addressLocationModel';

export const addressParts = ['unit_no', 'building', 'street', 'area', 'city', 'landmark'];
export const requiredAddressFields = ['name', 'number', 'unit_no', 'building', 'area', 'city'];
const text = value => String(value ?? '').trim();

export function composeStructuredAddress(form) {
  const address = ['unit_no', 'building', 'street', 'area', 'city'].map(key => text(form[key])).filter(Boolean).join(', ');
  return address + (text(form.landmark) ? ` (near ${text(form.landmark)})` : '');
}

export function missingAddressFields(form) {
  return requiredAddressFields.filter(key => !text(form?.[key]) || (key === 'number' && !text(form?.[key]).replace(/\D/g, '')));
}

export function locationStepError(form) {
  if (validPin(form.latitude, form.longitude)) return '';
  if (!form.no_pin_reason) return 'Set a location pin or choose a reason.';
  if (form.no_pin_reason === 'other' && !text(form.no_pin_note)) return 'Explain why the address has no pin.';
  if (text(form.no_pin_note).length > 500) return 'The note must be at most 500 characters.';
  return '';
}

export function addressEditorForm(row) {
  return { ...row, number: String(row.number ?? '').replace(/\D/g, ''), delivery_mode: 'own', _step: 2,
    _typed: Object.fromEntries(addressParts.filter(key => text(row[key])).map(key => [key, true])),
    _fromMap: {},
  };
}

export function applyAddressLocation(form, patch) {
  const next = { ...patch, delivery_mode: 'own', _fromMap: { ...form._fromMap } };
  for (const key of ['building', 'street', 'area', 'city']) {
    if (!Object.prototype.hasOwnProperty.call(patch, key)) continue;
    if (form._typed?.[key]) delete next[key];
    else { next[key] = patch[key] || ''; next._fromMap[key] = Boolean(patch[key]); }
  }
  if (validPin(patch.latitude, patch.longitude)) Object.assign(next, { no_pin_reason: null, no_pin_note: null });
  return next;
}

export function noPinPatch(reason) {
  return { latitude: null, longitude: null, location_source: 'none', map_address: null,
    country_code: null, region: null, no_pin_reason: reason, no_pin_note: null };
}
